import type { ChatMessageResponseAllOf } from './chatMessageResponseAllOf';
import type { ChatMessageResponseAllOfOnezero } from './chatMessageResponseAllOfOnezero';

export type ChatMessageResponse = ChatMessageResponseAllOf & ChatMessageResponseAllOfOnezero;
